"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expandTilde = void 0;
const os_1 = require("os");
const path_1 = require("path");
// https://www.ibm.com/support/knowledgecenter/en/SSVJJU_6.4.0/com.ibm.IBMDS.doc_6.4/r_cr_asciicharset.html
exports.expandTilde = (path) => {
    const home = os_1.homedir();
    if (path.charCodeAt(0) === 126) {
        if (path.charCodeAt(1) === 43) {
            return path_1.join(process.cwd(), path.slice(2));
        }
        return path_1.join(home, path.slice(1));
    }
    return path;
};
//# sourceMappingURL=expand-tilde.js.map